// BootstrapのJavaScript側の機能を読み込む
import "bootstrap";

// スタイルシートを読み込む
import "./index.scss";
